import store from "services/structure/store";

export const AUTH_DATA_KEY = "AuthData";
export const isAuthenticated = () => store.getState()?.authState?.token != null;
